import $ from "jquery";

window.$ = window.jQuery = $;

import('./zukan_main')
